<p-sidebar [visible]="isVisibleFilters()" position="right" [modal]="false" [showCloseIcon]="false" [transitionOptions]="'200ms'">
  <div class="filter_content">
    <div class="flex flex-between" style="align-items: unset!important; flex-direction: row; width: 100%; padding: 16px 16px 12px 16px; border-bottom: 1px solid #E5E5E5">
      <div class="filter_name" style="margin-right: auto;">
        Фільтр
      </div>
      <div style="margin-left: auto" class="flex-between flex">
        <div style="margin-right: 16px"><med-icon-refresh [ngStyle]="{'width': '16px', 'cursor': 'pointer'}" (click)="filter.resetFilter('/distributions/doz')"></med-icon-refresh></div>
        <div><med-icon-close [ngStyle]="{'width': '16px', 'cursor': 'pointer'}" (click)="this.filter.distributionsDOZFilter = false"></med-icon-close></div>
      </div>
    </div>
    <div style="width: 100%; padding-left: 16px; padding-right: 25px">

      <div style="width: 100%;">
        <med-input
          size="small"
          [hideClearBtn]="true"
          placeholder="Номер"
          label="Номер"
          [(ngModel)]="filter.distributionsDOZ.number[0]"
          (focusout)="filter.distributionsDOZStateChange()"
        ></med-input>
      </div>
      <div style="width: 100%;">
<!--        <med-input-->
<!--          size="small"-->
<!--          [hideClearBtn]="true"-->
<!--          placeholder="Дата"-->
<!--          label="дата"-->
<!--          [(ngModel)]="filter.distributionsDOZ.createdAt[0]"-->
<!--          (focusout)="filter.distributionsDOZStateChange()"-->
<!--        ></med-input>-->
        <med-datepicker
          size="small"
          [mode]="'range'"
          label="Дата"
          placeholder="Оберіть дату"
          [(ngModel)]="filter.distributionsDOZ.createdAt"
          (ngModelChange)="filter.distributionsDOZStateChange()"
        ></med-datepicker>
      </div>
      <div style="width: 100%;">
        <med-multi-select
          size="small"
          [hideClearBtn]="true"
          placeholder="{{ !filter.distributionsDOZ.status.length ? 'Всі': 'Обрано фільтрів: ' + filter.distributionsDOZ.status.length }}"
          label="Статус"
          [options]="statusTranslatorService.getStatuses()"
          [(ngModel)]="filter.distributionsDOZ.status"
          (ngModelChange)="filter.distributionsDOZStateChange()"
        ></med-multi-select>
      </div>

      <div style="width: 100%;">
        <med-input
          size="small"
          [hideClearBtn]="true"
          placeholder="МНН"
          label="МНН"
          [(ngModel)]="filter.distributionsDOZ.mnn[0]"
          (focusout)="filter.distributionsDOZStateChange()"
        ></med-input>
      </div>

      <div style="width: 100%;">
        <med-input
          size="small"
          [hideClearBtn]="true"
          placeholder="Напрям"
          label="Напрям"
          [(ngModel)]="filter.distributionsDOZ.direction[0]"
          (focusout)="filter.distributionsDOZStateChange()"
        ></med-input>
      </div>
      <div style="width: 100%;">
        <med-input
          size="small"
          [hideClearBtn]="true"
          placeholder="Піднапрям"
          label="Піднапрям"
          [(ngModel)]="filter.distributionsDOZ.subDirection[0]"
          (focusout)="filter.distributionsDOZStateChange()"
        ></med-input>
      </div>
      <div style="width: 100%;">
        <med-input
          size="small"
          [hideClearBtn]="true"
          placeholder="Розподілена кількість"
          label="Розподілена кількість"
          [(ngModel)]="filter.distributionsDOZ.distributedQuantity[0]"
          (focusout)="filter.distributionsDOZStateChange()"
        ></med-input>
      </div>
    </div>
  </div>
</p-sidebar>

<app-page-title></app-page-title>

<app-loader [hidden]="loadingCounter === 0"></app-loader>

<div class="table-wrapper" *ngIf="dataService.isDOZ()" [hidden]="loadingCounter > 0">
  <p-table #distributionTable [value]="distributions"
           [tableStyle]="{ 'min-width': '50rem' }"
           styleClass="p-datatable-sm"
           [scrollable]="true"
           scrollHeight="flex"
           [customSort]="true"
           [lazy]="true"
           [resizableColumns]="true"
           columnResizeMode="expand"
           [columns]="tabHeaderForDOZ"
           [reorderableColumns]="true"
           (onLazyLoad)="loadData($event)"
           (onColReorder)="saveColumnOrder()">

    <ng-template pTemplate="header">
      <tr>
        <th class="table-header-text table-header-bg-grey" [pSortableColumn]="column.key" *ngFor="let column of tabHeaderForDOZ" style="min-width: 10em" pReorderableColumn pResizableColumn>
          <div style="display: inline-block" class="flex align-items-center" [ngStyle]="{'max-width': ['8', '11'].includes(column.key) ? '10em': 'initial'}" [ngClass]="{'no-wrap': ['8', '11'].includes(column.key)}">
            {{ column.label }}&nbsp;
            <p-sortIcon [field]="column.key" *ngIf="filterActive && filterField === column.key"></p-sortIcon>
          </div>
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-row let-columns="columns" let-rowIndex="rowIndex">
      <tr class="table-content-text" (dblclick)="goToDistribution(row['distributionId'], row['distributionType'], row['parentId'], row['id'])" [ngClass]="{'purple-10-background': isRowOpened(row)}">
        <ng-container *ngFor="let col of columns">
        <td class="h10-text black-80" *ngIf="col.key === 'id'">

          <div class="flex gap-1">
            <div><med-icon-triangle-down size="16" [ngStyle]="{'cursor': 'pointer'}" (click)="expandRow(row, rowIndex)" *ngIf="!isRowOpened(row) && row['id'] && row['distributionType'] !== 'ДОЗ'"></med-icon-triangle-down></div>
            <div><med-icon-triangle-up size="16" [ngStyle]="{'cursor': 'pointer'}" (click)="closeRow(row, rowIndex)" *ngIf="isRowOpened(row) && row['id'] && row['distributionType'] !== 'ДОЗ'"></med-icon-triangle-up></div>

            <a (click)="goToDistribution(row['distributionId'], row['distributionType'], row['parentId'], row['id'])" style="cursor: pointer" *ngIf="row['distributionType'] !== 'ДОЗ'">
              {{row['distributionId']}}
            </a>

            <a (click)="goToSubDistribution(row['id'], row['parentId'])" class="text-gray-400" style="cursor: pointer" *ngIf="row['distributionType'] === 'ДОЗ'">
              {{row['parentId']}}.{{row['index']}}
            </a>
          </div>
        </td>

        <td class="h10-text black-80" *ngIf="col.key === 'order_date'">
          <div *ngIf="row['id'] && row['distributionType'] !== 'ДОЗ'">{{row['createdAt'] | date: 'dd.MM.yyyy'}}</div>
          <div *ngIf="row['id'] && row['distributionType'] === 'ДОЗ'" class="text-gray-400">{{row['createdAt'] | date: 'dd.MM.yyyy'}}</div>
        </td>

        <td class="h10-text black-80" *ngIf="col.key === 'status'">
          <div class="h10-text"
               style="display: flex; flex-direction: row; width: 18em" *ngIf="row['signStatus']"><img [src]="getPathToStatusImg(row['signStatus'])" width="4" height="16" style="vertical-align: middle;"/>&nbsp; {{statusTranslatorService.getStatusForString(row['signStatus'])}}</div>
          <div class="h10-text"
               style="display: flex; flex-direction: row; width: 18em" *ngIf="!row['signStatus'] && !row['parentId']"><img [src]="getPathToStatusImg('PENDING_APPROVAL')" width="4" height="16" style="vertical-align: middle;"/>&nbsp; Очікує рішення</div>
          <div class="h10-text"
               style="display: flex; flex-direction: row; width: 18em" *ngIf="!row['signStatus'] && row['parentId']"><img [src]="getPathToStatusImg(row['status'])" width="4" height="16" style="vertical-align: middle;"/>&nbsp; {{statusTranslatorService.getStatusForString(row['status'])}}</div>
        </td>

        <td class="h10-text black-80" *ngIf="col.key === 'mnn'">
          <div *ngIf="row['id']">
            {{row['mnnId']}}
<!--            <med-bubble *ngFor="let spec of row['goodSpecifications']; trackBy: trackByIndex"-->
<!--                        [styleClass]="'med-bubble-white'">-->
<!--              <div id="{{ 'bubble_distributions_mnn_' + spec['specificationId'] + '_' + row['id'] }}"-->
<!--                   class="h10-text" tooltipEvent="focus"-->
<!--                   (clickOutside)="showTooltip('bubble_distributions_mnn_' + spec['specificationId'] + '_' + row['id'], false)"-->
<!--                   [pTooltip]="tooltipContentmnn" [autoHide]="false"-->
<!--                   (click)="showTooltip('bubble_distributions_mnn_' + spec['specificationId'] + '_' + row['id'], true)">-->

<!--                <div class="flex-12rem">-->
<!--                        <span class="truncate-text cursor-pointer" [pTooltip]="tooltipmnnName">-->
<!--                          {{spec['good']['mnnName']}}-->
<!--                        </span>-->
<!--                  <ng-template #tooltipmnnName>-->
<!--                    <div class="flex items-center h10-text">-->
<!--                      {{spec['good']['mnnName']}}-->
<!--                    </div>-->
<!--                  </ng-template>-->
<!--                </div>-->
<!--              </div>-->

<!--              <ng-template #tooltipContentmnn>-->
<!--                &lt;!&ndash;            <div class="flex items-center h10-text">&ndash;&gt;-->
<!--                &lt;!&ndash;              {{row['direction']['name']}}&ndash;&gt;-->
<!--                &lt;!&ndash;            </div>&ndash;&gt;-->
<!--                <div class="doz-tooltip-content">-->
<!--                  <div class="flex flex-between justify-content-center grid-nogutter" style="width: 100%; justify-content: space-between!important;">-->
<!--                    <div class="mobile-h10-text black-20 col-6">-->
<!--                      МНН:-->
<!--                    </div>-->
<!--                    <div style="color: white" class="h10-text col-6">-->
<!--                      {{spec['good']['mnnName']}}-->
<!--                    </div>-->
<!--                  </div>-->
<!--                  <div class="flex flex-between justify-content-center grid-nogutter" style="width: 100%; justify-content: space-between!important;">-->
<!--                    <div class="mobile-h10-text black-20 col-6">-->
<!--                      Дозування:-->
<!--                    </div>-->
<!--                    <div style="color: white" class="h10-text col-6">-->
<!--                      {{spec['good']['dosage']}}-->
<!--                    </div>-->
<!--                  </div>-->
<!--                  <div class="flex flex-between justify-content-center grid-nogutter" style="width: 100%; justify-content: space-between!important;">-->
<!--                    <div class="mobile-h10-text black-20 col-6">-->
<!--                      Виробник:-->
<!--                    </div>-->
<!--                    <div style=" color: white" class="h10-text col-6">-->
<!--                      {{spec['manufacturer'] +  " " + spec['manufacturerCountry']}}-->
<!--                    </div>-->
<!--                  </div>-->
<!--                  <div class="flex flex-between justify-content-center grid-nogutter" style="width: 100%; justify-content: space-between!important;">-->
<!--                    <div class="mobile-h10-text black-20 col-6">-->
<!--                      Торгова назва:-->
<!--                    </div>-->
<!--                    <div style=" color: white" class="h10-text col-6">-->
<!--                      {{spec['good']['tradeName']}}-->
<!--                    </div>-->
<!--                  </div>-->
<!--                  <div class="flex flex-between justify-content-center grid-nogutter" style="width: 100%; justify-content: space-between!important;">-->
<!--                    <div class="mobile-h10-text black-20 col-6">-->
<!--                      Одиниця виміру:-->
<!--                    </div>-->
<!--                    <div style=" color: white" class="h10-text col-6">-->
<!--                      {{spec['good']['unit']}}-->
<!--                    </div>-->
<!--                  </div>-->
<!--                  <div class="flex flex-between justify-content-center grid-nogutter" style="width: 100%; justify-content: space-between!important;">-->
<!--                    <div class="mobile-h10-text black-20 col-6">-->
<!--                      Кількість:-->
<!--                    </div>-->
<!--                    <div style=" color: white" class="h10-text col-6">-->
<!--                      {{spec['distributedQuantity']}}-->
<!--                    </div>-->
<!--                  </div>-->
<!--                  <div class="flex flex-between justify-content-center grid-nogutter" style="width: 100%; justify-content: space-between!important;">-->
<!--                    <div class="mobile-h10-text black-20 col-6">-->
<!--                      Ціна за одиницю грн.:-->
<!--                    </div>-->
<!--                    <div style=" color: white" class="h10-text col-6">-->
<!--                      {{spec['adjUnitPrice']}}-->
<!--                    </div>-->
<!--                  </div>-->
<!--                  <div class="flex flex-between justify-content-center grid-nogutter" style="width: 100%; justify-content: space-between!important;">-->
<!--                    <div class="mobile-h10-text black-20 col-6">-->
<!--                      Загальна вартість, грн:-->
<!--                    </div>-->
<!--                    <div style=" color: white" class="h10-text col-6">-->
<!--                      {{spec['adjUnitPriceTotal']}}-->
<!--                    </div>-->
<!--                  </div>-->

<!--                </div>-->
<!--              </ng-template>-->

<!--            </med-bubble>-->
          </div>
          <div *ngIf="!row['id']">
            <span *ngIf="row['mnn']">{{row['mnn'][0]}}</span>
          </div>
        </td>


        <td class="h10-text black-60" *ngIf="col.key === 'direction'">
          <div class="flex-12rem">
                        <span class="truncate-text" [pTooltip]="tooltipContent">
                            {{getDirectionName(row['direction'])}}
                        </span>
          </div>
          <ng-template #tooltipContent>
            <div class="flex items-center h10-text">
              {{row['direction']}}
            </div>
          </ng-template>
        </td>

        <td class="h10-text black-80" *ngIf="col.key === 'subDirection'">
          <ul class="list">
            <li class="small-text"><span class="small-text overflow">{{ row['subDirection'] }}</span></li>
          </ul>

        </td>

        <td class="h10-text black-80" *ngIf="col.key === 'recipientBase'">
          <p-scrollPanel [style]="{ height: '100px' }">
          <ul *ngIf="row['recipientBases']">
            <li *ngFor="let org of getBases(row['recipientBases'])" class="small-text">
              {{ org }}
            </li>
          </ul>
          </p-scrollPanel>
        </td>

<!--        <td class="h10-text black-80" *ngIf="col.key === 'distributed'">-->
<!--          <div *ngIf="row['distributionType'] !== 'ДОЗ'">-->
<!--            <p-progressBar *ngIf="row['id']" aria-labelledby="label_status" [value]="50"></p-progressBar>-->
<!--            <div *ngIf="row['id']" id="label_status" class="h10-text flex flex-between">-->
<!--              <div>-->
<!--                16/32-->
<!--              </div>-->
<!--              <div>-->
<!--                50%-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </td>-->

        <td class="h10-text black-80" *ngIf="col.key === 'action'">
          <med-bubble *ngIf="row['id'] && row['distributionType'] !== 'ДОЗ'">
            <div class="flex flex-between gap-1 justify-content-center" style="cursor: pointer">
              <div><med-icon-plus size="16"></med-icon-plus></div>
              <div class="mobile-h10-text" style="white-space: nowrap">Дочірній розподіл</div>
            </div>
          </med-bubble>
        </td>
      </ng-container>
      </tr>
    </ng-template>

    <ng-template pTemplate="summary">
      <div class="flex flex-center flex-between">
        <med-pagination
          [total]="totalRows"
          [page]="selectedPageNumber"
          [perPage]="pageSize"
          (pageChange)="pageChange($event)"
        ></med-pagination>

        <div class="small-text">
          Показано &nbsp;<strong>{{ getFirstShowedRowIndex() }}</strong>-<strong>{{ getFirstShowedRowIndex() + pageSize }}</strong> &nbsp;з {{ totalRows }}
        </div>

        <div>
          <span class="small-text">Кількість на сторінку</span>
          <med-radio-group
            mode="buttons"
            [value]="totalRows"
            [options]="paginationOptions"
            (onInput)="pageSizeChanged($event)"
          ></med-radio-group>
        </div>
      </div>
    </ng-template>

  </p-table>
</div>
